import { QueueCarriers } from '#components/QueueCarriers'
import { QueueStatus } from '#components/QueueStatus'

const DocumentQueueStatus = () => (
  <div className="space-y-6">
    <QueueStatus endpoint="documents/queue-status" />
    <QueueCarriers endpoint="documents/queue-breakdown" />
  </div>
)

export { DocumentQueueStatus }
